// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
export const SupportedCountryCodes = ['USA', 'PRI', 'BMU', 'CAN'];
